import styled from 'styled-components';

export const Container = styled.div`
  height: ${props => props.theme.space['5.2']} !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.capsuleGray00} !important;
`;

export const Text = styled.p`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleGray10} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
  text-transform: uppercase !important;
`;

export const ErrorCard = styled.div`
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body};
  font-weight: ${props => props.theme.fontWeights.roman};
  letter-spacing: ${props => props.theme.letterSpacings.one};
  background-color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.space.s5};
  color: ${props => props.theme.colors.capsuleGray50};
  box-shadow: ${props => props.theme.shadows.dp6};
  border-radius: ${props => props.theme.radii.small};
`;

export const LinkStyleButton = styled.button`
  font: inherit;
  border: none;
  cursor: pointer;
  background: transparent;
  color: ${props => props.theme.colors.capsuleBlue90};
  &:hover {
    color: ${props => props.theme.colors.capsuleGreen60};
    text-decoration: underline;
  }
`;

export const DateGroupContainer = styled.div`
  margin-top: ${props => props.theme.space.s3};
`;
